import { useWindowSize } from "@/hooks/useIsMobile";
import sendGAEvent from "@/utils/gaEvent";
import SVG from "react-inlinesvg";

const Breadcrumb = ({ breadcrumbList = [] }) => {
  const { width } = useWindowSize();

  const handleClick = (isVideoPage) => {
    const isStoryOrVideoDetail =
      window?.location?.href?.includes("/video/") ||
      window?.location?.href?.includes("/story/");
    if (isStoryOrVideoDetail) {
      sendGAEvent({
        eventName: isVideoPage
          ? "VideoPage-BreadcrumbsClick"
          : "ArticlePage-BreadcrumbsClick",
        pageTitle: document?.title,
        pageLocation: window?.location?.href,
      });
    }
  };

  return (
    <div className="bg-gray-100 py-2">
      <nav className="text-gray-700 text-sm md:mx-4" aria-label="Breadcrumb">
        <ol className="list-none mx-2 md:mx-0 p-0 inline-flex divide-x-2">
          <li className="flex items-center px-2">
            <a
              href="/"
              className="text-gray-700 hover:text-primary flex"
              onClick={() => handleClick(false)}
            >
              {/* <div className="min-w-[14px] flex items-center">
                <SVG
                  className="w-3 h-3 mx-1 hover:text-primary"
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/menuHome.svg"
                />
              </div> */}
              होम
            </a>
          </li>
          {breadcrumbList?.map((item, idx) => (
            <li key={idx} className="flex items-center px-2">
              {item?.icon && (
                <div className="min-w-[14px] flex items-center">
                  <SVG
                    className="w-3 h-3 mx-1 hover:text-primary"
                    src={item?.icon}
                  />
                </div>
              )}
              {breadcrumbList.length === idx + 1 ? (
                <p className="text-gray-700 whitespace-nowrap">
                  {width < 900
                    ? idx == 3 && (item?.title?.length) > 12
                      ? `${item?.title.slice(0, 12)} ...`
                      : item?.title
                    : item?.title}
                </p>
              ) : (
                <a
                  href={item?.canonical_url}
                  className="text-gray-700 hover:text-primary whitespace-nowrap"
                  onClick={() =>
                    handleClick(window?.location?.href?.includes("/video/"))
                  }
                >
                  {item?.title}
                </a>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
